export default __webpack_public_path__ + "static/media/Account-Info-active.10d642a7.jpg";